<div class="navigation-button-wrapper" [class.active]="isActive" [class.internal]="isInternal">
  <i *ngIf="icon && isActive" i-bs [name]="icon"></i>
  <span class="navigation-title" [innerHTML]="title"></span>
</div>
